import React from "react";
import { Link } from "react-router-dom";
import { usePublicPages } from "../../contexts/PublicPagesContext";
import styles from "../../styles/pages/static/NotFoundPage.module.css";
import PageSeo from "../../components/common/PageSeo";

const NotFoundPage = () => {
  const { isPageEnabled } = usePublicPages();

  return (
    <div className="pageContainer">
      <PageSeo title="Page Not Found" noIndex />
      <div className="innerContainer">
        <main className={styles.container} aria-labelledby="not-found-title">
          <div className={styles.card}>
            <p className={styles.code}>404</p>
            <h1 id="not-found-title" className={styles.title}>
              Page not found
            </h1>
            <p className={styles.description}>
              The page you are trying to reach does not exist or may have been moved.
            </p>
            <div className={styles.actions}>
              <Link to="/" className={styles.primaryAction}>
                Home
              </Link>
              {isPageEnabled("feed") && (
                <Link to="/community" className={styles.secondaryAction}>
                  Browse Feed
                </Link>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default NotFoundPage;
